import { ImageComponent } from './ImageComponent'

export { ImageComponent }
export default ImageComponent
